import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import ReversalTransactionInfo from './ReversalTransactionInfo';

type ReversalTransactionContainerProps = vp.TransactionId & { jwt: string };

type FC = FunctionComponent<ReversalTransactionContainerProps>;

const ReversalTransactionContainer: FC = (props: ReversalTransactionContainerProps) => {
  const { TransactionID, jwt } = props;

  return <div>{TransactionID && <ReversalTransactionInfo TransactionId={TransactionID} jwt={jwt} />}</div>;
};

export default ReversalTransactionContainer;
